"use strict";
exports.__esModule = true;
var NOTIFICATION_TYPES = {
    DEFAULT: {
        label: 'Default',
        tooltip: '',
        type: 'default',
    },
    CUSTOM: {
        label: 'Custom',
        tooltip: '',
        type: 'custom',
    },
};
exports["default"] = NOTIFICATION_TYPES;
